import {
  GridColDef,
  GridColumnHeaderParams,
  GridRenderCellParams,
} from '@mui/x-data-grid';
import {t} from 'i18next';
import ArrButton from '../../../common/arr-button/ArrButton';
import {Box} from '@mui/material';

interface GetCommentsListGridColumnsProps {
  handleDelete?: (params: GridRenderCellParams) => void;
}

export const getCommentsListGridColumns = (
  props: GetCommentsListGridColumnsProps
): GridColDef[] => {
  return [
    {
      field: 'commentLabel',
      headerName: t('manageCommentFields.gridColumns.name'),
      renderHeader: (param: GridColumnHeaderParams) => (
        <div
          tabIndex={0}
          role="rowheader"
          className="table_header"
          data-testid={`comments-list-grid-columns-comment-label-header`}
        >
          {param.colDef.headerName}
        </div>
      ),
      flex: 3,
      headerClassName: 'typo-text label2_size',
      renderCell: (params: GridRenderCellParams) => {
        return (
          <span
            tabIndex={0}
            role="gridcell"
            aria-label={`row for ${params?.value}`}
            className="table_cells"
            data-testid={`comments-list-grid-columns-comment-label-${params.id}`}
          >
            {params.value}
          </span>
        );
      },
    },
    {
      field: '',
      headerName: t('manageCommentFields.gridColumns.actions'),
      renderHeader: (param: GridColumnHeaderParams) => (
        <div
          tabIndex={0}
          role="rowheader"
          className="table_header"
          data-testid={`comments-list-grid-columns-actions-header`}
        >
          {param.colDef.headerName}
        </div>
      ),
      flex: 1,
      headerClassName: 'typo-text label2_size',
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Box className={'comments-grid-actions'}>
            <ArrButton
              dataTestId={`delete-comment-field-${params.id}`}
              variant="secondary"
              size="xs"
              onClick={() => props.handleDelete?.(params)}
              onKeyDown={(e) => {
                if (e.key === ' ') {
                  e.stopPropagation();
                  props.handleDelete?.(params);
                }
              }}
            >
              {t('common.delete')}
            </ArrButton>
          </Box>
        );
      },
    },
  ];
};
